import { Button } from "common/components/ui/Button";
import type { SubscriptionType } from "common/types";

import SubscriptionCard from "./SubscriptionCard";
import SubscriptionTypeCards from "./SubscriptionTypeCards";

import type { Dispatch, ReactNode, SetStateAction } from "react";

import LockedIcon from "assets/icons/locked.svg?react";

interface DesktopLayoutProps {
  title: string;
  subscriptionType: SubscriptionType;
  startTrialButton: ReactNode;
  setSubscriptionType: Dispatch<SetStateAction<SubscriptionType>>;
  onContinue: () => void;
}

export default function DesktopLayout({
  title,
  subscriptionType,
  startTrialButton,
  setSubscriptionType,
  onContinue,
}: DesktopLayoutProps) {
  return (
    <section className="flex size-full items-center justify-center">
      <div className="w-[900px] h-[540px] rounded-4xl p-1.5 bg-white">
        <div className="flex h-full border border-black-200 rounded-3xl overflow-hidden shadow-md">
          <div className="flex flex-col gap-y-9 px-9 pt-12 pb-6 w-[381px]">
            <div className="flex gap-x-4">
              <LockedIcon />

              <div className="flex flex-col gap-y-1">
                <h2 className="text-lg-bold text-left">{title}</h2>
                <p className="text-sm-medium text-black-500 text-left">
                  Choose a plan to proceed:
                </p>
              </div>
            </div>

            <SubscriptionTypeCards
              subscriptionType={subscriptionType}
              setSubscriptionType={setSubscriptionType}
            />

            {startTrialButton || (
              <Button onClick={onContinue} className="mt-auto ml-auto">
                Continue
              </Button>
            )}
          </div>

          <div className="bg-whiteGray items-center justify-center flex grow">
            <SubscriptionCard type={subscriptionType} />
          </div>
        </div>
      </div>
    </section>
  );
}
